<span class="saving">
	<i class="icon-refresh icon-spin"></i> <span data-i18n="editor.saving"></span>&nbsp;
	<span class="queue-info">(<span class="queue-count">0</span> <span data-i18n="editor.savesQueued"></span>)</span>
</span>
<span class="last-saved">
	<i class="icon-save"></i> <span data-i18n="editor.lastSaved"></span> <span class="last-saved-date" data-i18n="editor.never"></span>
</span>
